<script>
import { PAGE_STATES } from '@/constants';

export default {
  data: () => ({
    pageStatus: ''
  }),
  computed: {
    loading () {
      return this.pageStatus === PAGE_STATES.LOADING || this.pageStatus === PAGE_STATES.START
    }
  },
  beforeMount() {
    this.pageStatus = PAGE_STATES.START
  },
  methods: {
    setPageLoading () {
      this.pageStatus = PAGE_STATES.LOADING
    },
    setPageSuccess () {
      setTimeout(() => this.pageStatus = PAGE_STATES.SUCCESS, 300)
    },
    setPageError () {
      this.pageStatus = PAGE_STATES.ERROR
    }
  }
}
</script>
